// extracted by mini-css-extract-plugin
module.exports = {"holder":"Holder_holder__1lwGL","img":"Holder_img__1EUtm","name":"Holder_name__30o4o","color":"Holder_color__3fYom"};